import type { ArAgingBridge, ArAgingBridgeBucket } from '../cfoArView'

export type ArAgingBridgeColumn =
  | { kind: 'start' | 'end'; label: string; total: number; segments: Array<{ label: string; value: number; tone: ArAgingBridgeBucket['tone'] }> }
  | { kind: 'delta'; label: string; delta: number; base: number; top: number; tone: ArAgingBridgeBucket['tone'] }

export function computeArAgingBridgeColumns(bridge: ArAgingBridge): ArAgingBridgeColumn[] {
  const columns: ArAgingBridgeColumn[] = [
    {
      kind: 'start',
      label: bridge.startLabel || 'Start',
      total: bridge.startTotal,
      segments: bridge.buckets.map((bucket) => ({ label: bucket.label, value: bucket.startValue, tone: bucket.tone })),
    },
  ]
  let running = bridge.startTotal
  for (const bucket of bridge.buckets) {
    const next = running + bucket.delta
    columns.push({
      kind: 'delta',
      label: bucket.label,
      delta: bucket.delta,
      base: Math.min(running, next),
      top: Math.max(running, next),
      tone: bucket.tone,
    })
    running = next
  }
  columns.push({
    kind: 'end',
    label: bridge.endLabel || 'End',
    total: bridge.endTotal,
    segments: bridge.buckets.map((bucket) => ({ label: bucket.label, value: bucket.endValue, tone: bucket.tone })),
  })
  return columns
}
